import React from "react";
import { partners } from "../data/partners";
export function Partners() {
  const loop = [...partners, ...partners];
  return <section aria-labelledby="partners-title" className="w-full border-y border-line bg-cream py-10" data-id="element-152" data-mp="23lc6d6njhvys">
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-6 lg:flex-row lg:items-center lg:gap-12 lg:px-10" data-id="element-153" data-mp="1plknari61pdx">
        <h2 id="partners-title" className="shrink-0 text-sm font-medium text-muted lg:w-48" data-id="element-154" data-mp="1ul6y6uaiutjk">
          Nos partenaires financiers et immobiliers
        </h2>
        <div className="relative overflow-hidden" data-id="element-155" data-mp="2m97di7oncbix">
          <ul className="animate-marquee flex w-max items-center gap-14" data-id="element-156" data-mp="2mc3d00g5789h">
            {loop.map((name, i) => <li key={`${name}-${i}`} aria-hidden={i >= partners.length} className="whitespace-nowrap font-serif text-2xl text-ink/45" data-id="element-157" data-mp="2dhynbkcqw2vj" data-mpi={i}>
                {name}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}